import { BaseComponent } from './base.component';

export class BillingBase extends BaseComponent {

    constructor() {
        super();
    }
}
